export default {
    getOrgTypeFunTypeStatus:'/auth/function/selected', //获取组织部门类型信息
    getSystemList: '/auth/res/system/all', //获取系统列表
    getFunList: '/auth/function/list', //获取职能包列表
    stopFunctional: '/auth/function/stopUsing', //职能包停用
    startFunctional: '/auth/function/reusing', //职能包启用
    deletFunctional: '/auth/function/delete', //职能包删除
    addFun: '/auth/function/addFunction', //职能包-新增
    updateFun: '/auth/function/updateFunction', //职能包-编辑
    getFunDetail:'/auth/function/detail', //职能包-详情
}


// WEBPACK FOOTER //
// ./src/api/functionalManagement.js